import styled, { css } from 'styled-components'

interface IWrapper {
  isdangerous: string
  secondaryIsPrimary: string
}

export const Wrapper = styled.div<IWrapper>`
  text-align: right;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  button {
    height: 40px;
    margin-left: 8px;
    border-radius: 8px;
    padding: 0 12px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border: none;
    font-weight: 700;

    svg {
      margin: 0;
    }

    ${(props) =>
      props.secondaryIsPrimary === 'true'
        ? css`
            color: white !important;
            background-color: rgb(38, 132, 255) !important;
            &:hover {
              color: rgba(255, 255, 255, 0.7) !important;
            }
            &:disabled {
              opacity: 0.48;
              color: white !important;
            }
          `
        : css`
            color: #4c4c4c !important;
            background-color: #f0f0f0 !important;
            &:hover {
              color: rgba(76, 76, 76, 0.7) !important;
            }
            &:disabled {
              opacity: 0.48;
              color: #4c4c4c !important;
            }
          `}
  }

  div {
    button {
      display: inline-flex !important;
      align-items: center;
      gap: 4px;
      color: white !important;
      ${(props) =>
        props.isdangerous === 'true'
          ? css`
              background-color: #f5222d !important;
            `
          : css`
              background-color: rgb(38, 132, 255) !important;
            `}
      &:hover {
        color: rgba(255, 255, 255, 0.7) !important;
      }
      &:disabled {
        opacity: 0.48;
        color: white !important;
      }
    }
  }
`
